import { render, staticRenderFns } from "./expend.vue?vue&type=template&id=20dc2f7a&"
import script from "./expend.vue?vue&type=script&lang=js&"
export * from "./expend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports